import { createAction, props } from '@ngrx/store';

export const mCommitmentsViewContractComponentActions = {
  loadPage: createAction(
    '[Manager Commitments View Contract Component] Load Page',
    props<{ contractId: number }>(),
  ),
};
